import { createContext, useContext } from "react"

export type NotificationType = "success" | "error"
export type NotificationContent = any | null
export interface Notification {
  type: NotificationType
  content: NotificationContent
  autohide: boolean
}

export interface NotificationContextType {
  showNotification: (notification: Notification) => void
  showSuccess: (text: NotificationContent) => void
  showError: (text: NotificationContent) => void
}

export const NotificationContext = createContext<NotificationContextType>({
  showNotification: () => {},
  showSuccess: () => {},
  showError: () => {}
})

const useNotifications = () => useContext(NotificationContext)

export default useNotifications
